import './assets/main.css';
import App from './App.vue';

import { i18n } from '@/i18n';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import router from './router/router';
import * as Sentry from '@sentry/browser';
import { environment } from '@/environment';

async function initializeApp() {
  try {
    const app = createApp(App);

    Sentry.init({
      dsn: environment.sentryDSN,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
      ],
      ignoreErrors: [/^zClient.on is not a function$/],
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      environment: environment.environment,
    });

    app.use(i18n);
    i18n.global.setMissingHandler((locale, key) => {
      Sentry.captureException(
        new Error(`Missing translation for key: ${key} - ${locale}`)
      );
      return i18n.global.t('translationMissing');
    });

    app.use(router);
    app.use(createPinia());
    app.mount('#app');
  } catch (error) {
    console.error('An error occurred during app initialization', error);
  }
}

initializeApp();
